import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledBox = styled(MuiBox)({}) as typeof MuiBox;
